import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { HostStripeMessageSchema, stripeBridgeEvent } from "@froppio/host-auth";
import { authService } from "@/core/auth/services/authService";
import { useAppResume } from "@/shared/hooks/useAppResume";
import { subscriptionKeys } from "../hooks/subscriptionQueries";

/** Stripe-hosted billing finishes outside the app; refresh the plan whenever the user comes back. */
export function SubscriptionHostRefresh({ businessId }: { businessId: string }) {
  const queryClient = useQueryClient();
  // Resume signals arrive in bursts; join an in-flight refresh instead of restarting it.
  const refresh = () => void queryClient.invalidateQueries({ queryKey: subscriptionKeys.detail(businessId) }, { cancelRefetch: false });
  useAppResume(refresh);
  useEffect(() => {
    const receive = (event: Event) => {
      if (authService.kind !== "host" || !(event instanceof CustomEvent)) return;
      const parsed = HostStripeMessageSchema.safeParse(event.detail);
      if (!parsed.success) return;
      if (parsed.data.type === "resume") void queryClient.invalidateQueries({ queryKey: subscriptionKeys.detail(businessId) }, { cancelRefetch: false });
      // A finished checkout must not reuse a request that started before it.
      if (parsed.data.type === "return") void queryClient.invalidateQueries({ queryKey: subscriptionKeys.detail(businessId) });
    };
    window.addEventListener(stripeBridgeEvent, receive);
    return () => window.removeEventListener(stripeBridgeEvent, receive);
  }, [businessId, queryClient]);
  return null;
}